import { render, staticRenderFns } from "./PartnerBalanceCard.vue?vue&type=template&id=47139198"
import script from "./PartnerBalanceCard.vue?vue&type=script&lang=js"
export * from "./PartnerBalanceCard.vue?vue&type=script&lang=js"
import style0 from "./PartnerBalanceCard.vue?vue&type=style&index=0&id=47139198&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports